export default __webpack_public_path__ + "static/B21-e9e41dda9fbbb17db7bdc0b578b00603.png";